import React from 'react'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

import InfiniteScroll from "react-infinite-scroll-component";

let strings = new LocalizedStrings({
    en:{
        title:"all possible poems",
        description:"all possible poems. one of them is a masterpiece for sure. which one? scroll down to find out."
    },
    de: {
        title:"alle möglichen gedichte",
        description:"alle potentiell möglichen gedichte. eines ist sicher ein meisterwerk. welches? scrolle hinunter, um es herauszufinden."
    }
});

class AllPoems extends React.Component {
    constructor(props) {
        super(props)

        this.number = []

        var items = []
        for(var i = 0; i < 200; i++) {
            items.push(this.getLine())
        }

        this.state = {items: items}
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    addToText = (pos) => {
        if (this.number[pos] === " " || this.number[pos] === null || this.number[pos] === undefined) {
            this.number[pos] = "a"
        }
        else {
            this.number[pos] = String.fromCharCode(this.number[pos].charCodeAt(0)+1)
            if (this.number[pos].charCodeAt(0) > "z".charCodeAt(0)) {
                this.number[pos] = " "
                this.addToText(pos+1)
            }
        }
    }

    getLine = () => {
        this.addToText(1)
        var str = ""

        for (var i = this.number.length-1; i > 0; i--) {
            str = str + this.number[i]
        }

        return str
    }

    fetchMoreData = () => {
        var items = []
        for(var i = 0; i < 20; i++) {
            items.push(this.getLine())
        }

        this.setState({
            items: this.state.items.concat(items)
        });
    };

    render() {
        strings.setLanguage(this.context.language)
        return <div className="poemDisplay">
            <InfiniteScroll
          dataLength={this.state.items.length}
          next={this.fetchMoreData}
          hasMore={true}
          loader={<h4>Loading...</h4>}
        >
          {this.state.items.map((item, index) => (
            <p key={index}>
              {item}
            </p>
          ))}
        </InfiniteScroll>
      </div>
    }
}
AllPoems.contextType = LanguageContext

export default AllPoems
